import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, isConnectable, id, selected }) => (
  <AerosNode id={id} type="gemini" selected={selected} isConnectable={isConnectable}>
    {data.typebotIntegration?.name}
  </AerosNode>
));
